module.exports = __webpack_public_path__ + "static/media/keyman-db-banner@2x.1fa202c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keyman-db-banner@2x.png
// module id = 1291
// module chunks = 1